<template>
    <el-dialog title="Supprimer du PIM" v-loading="loader" :visible.sync="display" width="50%">
        <span>Supprimer les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formRemovePim" ref="form" :model="form">
            <el-alert title="Attention" type="warning" :closable="false">
                <el-checkbox v-model="form.removePrestashop">Supprimer sur le Prestashop ?</el-checkbox>
                <el-checkbox v-if="form.removePrestashop" v-model="form.forceRemovePrestashop">Supprimer même si activer ?</el-checkbox>
                <el-checkbox v-model="form.forceDelete">Supprimer définitivement du PIM ?</el-checkbox>
            </el-alert>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Supprimer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';

export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                forceRemovePrestashop: false,
                removePrestashop: false,
                remove: false,
                forceDelete: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
            this.form.forceRemovePrestashop = false;
            this.form.removePrestashop = false;
            this.form.forceDelete = false;
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                mode: 'remove_pim',
                forceRemovePrestashop: this.form.forceRemovePrestashop,
                removePrestashop: this.form.removePrestashop,
                forceDelete: this.form.forceDelete,
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected

            let messageConfirm = 'Supprimer les produits du PIM (n\'affecte pas le prestashop) ?';

            if (this.form.removePrestashop) {
                messageConfirm = 'Supprimer les produits du PIM et du Prestashop ?';
            }

            this.$confirm(messageConfirm, 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios
                    .post('/products/bulk', datas)
                    .then(r => {
                        EventBus.$emit('products.list.refresh')
                        this.display = false;
                    })
                    .catch(() => {

                    })
                    .then(() => {
                        this.loader = false;
                    });
            }).catch(()=>{
                this.display = false;
                this.loader = false;
            })

        }
    }
};
</script>
